import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';
import { hasPermission } from '@pec/aion-ui-core/actions/userInfo';

const { Organization } = UserInfoActivitiesType;
const { Read } = ActivityAction;

type RouteParams = {
  organizationId: string;
};

export function usePermission() {
  const { organizationId } = useParams<RouteParams>();
  const { userInfo } = useSelector((state: CommonRootState) => state.userInfo);

  const hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(userInfo, action, resourceName);

  const hasOrganizationOnlyPermission = (action: ActivityAction = Read, resourceName: ActivityResourceName) => {
    const currentOrganizationId = organizationId || userInfo?.primaryOrganizationId;
    if (!currentOrganizationId) return false;
    if (userInfo) {
      const organizationScope = userInfo.activities.find(
        ({ id, type }) => id === currentOrganizationId && type === Organization
      );
      return organizationScope?.activities[resourceName]?.includes(action);
    }
    return false;
  };

  return {
    hasGlobalPermission,
    hasOrganizationOnlyPermission
  };
}
